module.exports = __webpack_public_path__ + "productspace.acc45c2ee0b5fbe1170443e394363b69.png";